import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function AboutPage() {
    const [aboutArray, setAboutArray] = useState<Service[]>([]);

    const getAboutPage = (): Array<Service> =>
        servicesData.filter((srv: Service) => srv.category === "Σχετικά");


    useEffect(() => {
        const aboutList = getAboutPage();
        setAboutArray(aboutList);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box>
            <Tabs variant="enclosed"
                colorScheme={useColorModeValue("primary", "light")}>
                <TabPanels>
                    <TabPanel>
                        {aboutArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
